(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["images-with-text"] && !Shopify.designMode) return;
  try {
     
document.addEventListener('DOMContentLoaded', function () {
  $('.images-with-text-slider').slick({
    dots: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
});
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kik-countdown-banner"] && !Shopify.designMode) return;
  try {
     
document.addEventListener('DOMContentLoaded', function () {
  $('.slider').slick({
    dots: true,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
});
 
  } catch(e) { console.error(e); }
})();
})();
